import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('featureFlagModule', {
      delinquencyFeatures: 'delinquencyFeatures'
    })
  },
  methods: {
    /**
     * Checks if a specific Delinquency Module feature is enabled for the client.
     * @param {string} featureKey - The feature key to check (e.g., 'collateralManager').
     * @returns {boolean} - True if the feature is enabled, false otherwise.
     */
    hasFeature(featureKey) {
      return true;
      return !!(
        this.delinquencyFeatures && this.delinquencyFeatures[featureKey]
      );
    }
  }
};
